import React, { useState } from 'react';
import { Spinner } from '@/components/ui/spinner';

import { useTranslation } from 'react-i18next';
import { GoalId, GoalRelatedGoal } from '../../types';
import { GoalAlignedToItem } from './GoalAlignedToItem';
import { AddAlignedGoalModal } from './AddAlignedGoalModal';
import Button from '../../../../../../../components/button';
import './GoalAlignedTo.css';

type Props = {
  sourceGoalId: GoalId;
  alignedTo: GoalRelatedGoal[];
  onAdd: (targetGoalId: GoalRelatedGoal) => Promise<void>;
  onRemove: (targetGoalId: GoalRelatedGoal) => Promise<void>;
  onLinkClick?: () => void;
  isProcessing: boolean;
};

export const GoalAlignedTo: React.FC<React.PropsWithChildren<Props>> = ({
  sourceGoalId,
  alignedTo,
  onLinkClick,
  onAdd,
  onRemove,
  isProcessing,
}) => {
  const { t } = useTranslation();
  const [addModalVisible, setAddModalVisible] = useState(false);

  return (
    <div className="p-3 rounded border goal-aligned-to">
      <h3 className="mb-2 d-flex align-items-center gap-2">
        {t('performanceReview.goals2.goalSidebar.alignedTo')}
        {isProcessing && <Spinner animation="border" size="sm" />}
      </h3>
      <div className="d-flex flex-column">
        {alignedTo.map((goal) => (
          <GoalAlignedToItem
            key={goal.id}
            goal={goal}
            currentGoalId={sourceGoalId.id}
            onRemove={() => onRemove(goal)}
            onLinkClick={onLinkClick}
          />
        ))}
      </div>
      <Button
        variant="link"
        className="p-0 mt-2"
        size="sm"
        label={'+ ' + t('performanceReview.goals2.goalAlignedTo.alignToGoal')}
        onClick={() => setAddModalVisible(true)}
        disabled={isProcessing}
      />
      <AddAlignedGoalModal
        visible={addModalVisible}
        onClose={() => setAddModalVisible(false)}
        sourceGoalId={sourceGoalId}
        alignedTo={alignedTo}
        onAdd={onAdd}
        isProcessing={isProcessing}
      />
    </div>
  );
};
